import { call, put, takeLatest } from "redux-saga/effects";
import axiosInstance from "../../../axios/axiosInstance";
import { notify } from "../../../utils/notification";
import {logOut} from '../../../utils/helpers/logout'
import * as types from "../../constants";
import apiEndpoints from "../../../axios/api";
import { logger } from "../../../utils/logging";

export const getActivityListByDateReq = async({data})=>{
    return axiosInstance.get(`${apiEndpoints.GET_ACTIVITY_LIST_BY_DATE_API}?date=${data?.date}`)
        .then(response => {
            return response;
        }).catch((errors) => {
            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* getActivityListByDate({data}){
    try{
        let result = yield call(getActivityListByDateReq, {data})
        if(result.statusCode === 200){
            yield put({ type: types.GET_ACTIVITY_LIST_BY_DATE_SUCCESS, payload: result.data});
        }else{
            yield put({type: types.GET_ACTIVITY_LIST_BY_DATE_FALIURE})
        }
        
    }catch(error){
        logger.log(error)
    }
}

export const getActivityDetailsReq = async({data})=>{
    return axiosInstance.get(`${apiEndpoints.GET_ACTIVITY_DETAILS_API}?activity_id=${data?.activityId}`)
        .then(response => {
            return response;
        }).catch((errors) => {
            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* getActivityDetails({data}){
    try{
        let result = yield call(getActivityDetailsReq, {data})
        if(result.statusCode === 200){
            yield put({ type: types.GET_ACTIVITY_DETAILS_SUCCESS, payload: result.data});
        }else{
            yield put({type: types.GET_ACTIVITY_DETAILS_FALIURE})
        }
        
    }catch(error){
        logger.log(error)
    }
}

export const getInterestedUserListReq = async({data})=>{
    return axiosInstance.get(`${apiEndpoints.GET_INTERESTED_USER_LIST_API}?activity_id=${data?.id}`)
        .then(response => {
            return response;
        }).catch((errors) => {
            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* getInterestedUserList({data}){
    try{
        let result = yield call(getInterestedUserListReq, {data})
        if(result.statusCode === 200){
            yield put({ type: types.GET_INTERESTED_USER_LIST_SUCCESS, payload: result.data});
        }else{
            yield put({type: types.GET_INTERESTED_USER_LIST_FALIURE})
        }
        
    }catch(error){
        logger.log(error)
    }
}

export const getActiveUsersListForGroupActivityReq = async({data})=>{
    return axiosInstance.get(`${apiEndpoints.GET_ACTIVE_USER_LIST_FOR_GROUP_ACTIVITY_API}?page=${data.page || 1}&limit=${data.limit || 10}&activity_id=${data.id}${data.searchText ? `&search_text=${data.searchText}` : ''}`)
        .then(response => {
            return response;
        }).catch((errors) => {
            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* getActiveUsersListForGroupActivity({data}){
    try{
        let result = yield call(getActiveUsersListForGroupActivityReq, {data})
        if(result.statusCode === 200){
            yield put({ type: types.GET_ACTIVE_USER_LIST_FOR_GROUP_ACTIVITY_SUCCESS, payload: result.data});
        }else{
            yield put({type: types.GET_ACTIVE_USER_LIST_FOR_GROUP_ACTIVITY_FALIURE})
        }
        
    }catch(error){
        logger.log(error)
        yield put({type: types.GET_ACTIVE_USER_LIST_FOR_GROUP_ACTIVITY_FALIURE})
    }
}

export const addActiveUsersListToGroupActivityReq = async({data})=>{
    const BODY = {
        "user_program_ids": data?.users,
        "activity_id": data?.activityId
      }

      return axiosInstance.post(apiEndpoints.ADD_USER_TO_GROUP_ACTIVITY_API, { data: BODY})
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);
            if (errors.response?.data.statusCode === 400) {
              notify('error', errors.response.data.message);
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* addActiveUsersListToGroupActivity({data}){
    try{
        let result = yield call(addActiveUsersListToGroupActivityReq, {data})

        if(result.statusCode === 200){
            data?.onSuccessCallback?.()
            yield put({ type: types.ADD_USER_TO_GROUP_ACTIVITY_SUCCESS, payload: {userIds: data?.users}});
            notify('success', result.message);
        }
        yield put({ type: types.ADD_USER_TO_GROUP_ACTIVITY_FALIURE});

    }catch(error){
        yield put({ type: types.ADD_USER_TO_GROUP_ACTIVITY_FALIURE});
        logger.log(error)
    }
}


export const removeUserFromGroupActivityReq = async({data})=>{
    const BODY = {
        "user_id": data?.userId,
        "activity_id": data?.activityId
      }

      return axiosInstance.put(apiEndpoints.REMOVE_USER_FROM_GROUP_ACTIVITY_API, { data: BODY})
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);
            if (errors.response?.data.statusCode === 400) {
              notify('error', errors.response.data.message);
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* removeUserFromGroupActivity({data}){
    try{
        let result = yield call(removeUserFromGroupActivityReq, {data})

        if(result.statusCode === 200){
            yield put({ type: types.REMOVE_USER_FROM_GROUP_ACTIVITY_SUCCESS, payload: {userId: data?.userId}});
            notify('success', "Guest removed succesfully");
        }
        yield put({ type: types.REMOVE_USER_FROM_GROUP_ACTIVITY_FALIURE});
        data?.onSuccessCallback?.()

    }catch(error){
        yield put({ type: types.REMOVE_USER_FROM_GROUP_ACTIVITY_FALIURE});
        logger.log(error)
    }
}


function* groupClassesAndActiviytySaga(){
    yield takeLatest(types.GET_ACTIVITY_LIST_BY_DATE, getActivityListByDate);
    yield takeLatest(types.GET_ACTIVITY_DETAILS, getActivityDetails);
    yield takeLatest(types.GET_INTERESTED_USER_LIST, getInterestedUserList);
    yield takeLatest(types.GET_ACTIVE_USER_LIST_FOR_GROUP_ACTIVITY, getActiveUsersListForGroupActivity);
    yield takeLatest(types.ADD_USER_TO_GROUP_ACTIVITY, addActiveUsersListToGroupActivity);
    yield takeLatest(types.REMOVE_USER_FROM_GROUP_ACTIVITY, removeUserFromGroupActivity);

}

export default groupClassesAndActiviytySaga;